import React from "react";
import { withRouter } from "react-router-dom";
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import emp1 from "assets/img/homepage/employer/employer_help_hire.png";

const GustoOverlay = ({ history }) => {


    const onCloseModal = () => {
        history.push("/employers");
    };

    return (
        <Modal isOpen={true} className="pricing-overlay rounded_modal modal-lg" toggle={onCloseModal}>
            <ModalBody>
                <section className="pricing_post_a_job">
                    <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h3>Thanks for visiting us from Gusto!</h3>
                    <Row>
                        <Col xs="12" lg="6" >
                            <img className="img-fluid rounded hireImg d-none d-md-block" src={emp1} alt="The scale you need for success" />
                        </Col>
                        <Col xs="12" lg="6" className="text-center">
                            <div className="price_range_text">
                                <p style={{"fontSize":"30px"}}>Using Upward, you can boost your jobs on most major US job sites and get more candidates fast.</p>
                            </div>
                        </Col>
                    </Row>
                </section>
                <section style={{"border-radius":"0 0 25px 25px"}} className="pricing_how_it_works upward_vertical_getall">
                    <h3>Where would you like to start?</h3>
                    <Row>
                        <Col lg="12" className="upward_vertical_getall_wrapper" style={{"marginBottom":"20px"}}>
                            <div className="clearfix">
                                <div className="">
                                    <h4 style={{fontSize:"35px"}}>1. Create New Job Post</h4>
                                </div>
                                <div className="">
                                    <p style={{"fontSize":"17px"}}>To start a new job post, we rely on information sent from Gusto. Please return to your job posting within Gusto and follow these instructions:</p>
                                    <ol style={{"fontSize":"17px"}}>
                                        <li>From within your job description, select “Distribution”</li>
                                        <li>Scroll down to the Upward tile and select “Learn More” </li>
                                        <li>Click “Sponsor on Upward”. An overlay will load with instructions.</li>
                                        <li>Click “Create Account”. This both creates your account using the email on file with Gusto, and populates the job into your Upward account automatically. </li>
                                        <li>You'll receive an email from @Upward.net with further instructions, including how to add budgets, payment information, and users.</li>
                                    </ol>
                                    <p style={{"fontSize":"17px"}}>If you've already followed these steps for this same job in the past, or you have any questions at all, please reach out to us at <a href="mailto:gusto@jobcase.com">gusto@jobcase.com</a> for assistance.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="upward_vertical_getall_wrapper" style={{"marginBottom":"20px"}}>
                            <div className="clearfix">
                                <div className="">
                                    <h4 style={{fontSize:"35px"}}>2. Manage Job Promotion</h4>
                                </div>
                                <div className="">
                                    <p style={{"fontSize":"17px"}}>If you've already posted the job from within Gusto, you can <a href="https://www.upward.net/employers?register=y&src=gusto">create your Upward account</a> and add more budget here for as low as $25. Note that after you add promotion budget, you'll return to Gusto to track your candidates. Click <a href="https://www.upward.net/employers?signin=y&src=gusto">here to sign in</a> to an existing account.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="upward_vertical_getall_wrapper" style={{"marginBottom":"20px"}}>
                            <div className="clearfix">
                                <div className="">
                                    <h4 style={{"fontSize":"35px"}}>3. Request Help</h4>
                                </div>
                                <div className="">
                                    <p style={{"fontSize":"17px"}}>Someone from our team will respond within 12 business hours.</p>
                                    <a style={{"fontSize":"17px"}} href="mailto:gusto@jobcase.com">gusto@jobcase.com</a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </section>
            </ModalBody>
        </Modal>
    )

}

export default withRouter(GustoOverlay);